// Card de sección (`.card` + `.card-head` del mock): encabezado numerado en uppercase + hint a la
// derecha, cuerpo libre y nota al pie opcional (`.fordev`: referencia/nota en mono). Patrón
// repetido en la mayoría de pantallas del backoffice (config, políticas, conciliación, etc.).
import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export function SectionCard({
    title,
    meta,
    footnote,
    className,
    children,
}: {
    /** Título del encabezado (p.ej. "1 · Wizard · ventanas de tiempo"). */
    title: ReactNode;
    /** Hint a la derecha del encabezado. */
    meta?: ReactNode;
    /** Nota al pie en mono (referencias doc / aclaraciones "For Dev"). */
    footnote?: ReactNode;
    className?: string;
    children: ReactNode;
}) {
    return (
        <section
            className={cn('overflow-hidden rounded-md border border-border bg-card', className)}
        >
            <header className="flex items-center justify-between gap-2 border-b border-border bg-muted/30 px-2.5 py-1.5">
                <span className="text-[11.5px] font-semibold uppercase tracking-wide">{title}</span>
                {meta ? <span className="text-[10.5px] text-muted-foreground">{meta}</span> : null}
            </header>
            {children}
            {footnote ? (
                <div className="border-t border-border bg-muted/40 px-3 py-2 font-mono text-[10.5px] text-muted-foreground [&_strong]:font-semibold [&_strong]:text-foreground">
                    {footnote}
                </div>
            ) : null}
        </section>
    );
}
